export const tryExtractJsonErrorDescription = (
  rawText: string
): string | null => {
  try {
    if (typeof rawText !== "string") {
      return null;
    }
    const firstBrace = rawText.indexOf("{");
    const lastBrace = rawText.lastIndexOf("}");
    if (firstBrace === -1 || lastBrace === -1 || lastBrace <= firstBrace) {
      return null;
    }
    const candidate = rawText.slice(firstBrace, lastBrace + 1);
    const parsed = JSON.parse(candidate);
    const description = parsed?.errors?.[0]?.description;
    if (typeof description === "string" && description.trim().length > 0) {
      return description;
    }
    return null;
  } catch (_) {
    return null;
  }
};
